import { ButtonProps } from "@origin-digital/ods-core";
import { ActionSectionProps } from "./types";
import React from "react";

export const useActionSection = (props: ActionSectionProps) => {
  const newProjectButtonProps: ButtonProps = React.useMemo(() => {
    return {
      onClick: props.openDialog,
      "data-id": "actionSection.newProjectButton",
    };
  }, [props.openDialog]);

  return {
    newProjectButtonProps,
  };
};
